import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DateWrapper from '../../common/DateWrapper';
import DataAid from '../constants/data-aids';
import { UX2 } from '@wsb/guac-widget-core';
import getTimeZoneOffset from '../getTimeZoneOffset';

const styles = { display: 'inline-block' };

// eslint-disable-next-line no-bitwise
const HOUR_FORMAT = DateWrapper.HOUR | DateWrapper.MINUTE;

class EventTime extends Component {
  static get propTypes() {
    return {
      locale: PropTypes.string,
      allDay: PropTypes.bool,
      start: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
      end: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
      staticContent: PropTypes.object,
      isManual: PropTypes.bool.isRequired,
      order: PropTypes.number.isRequired,
      timezone: PropTypes.shape({ offset: PropTypes.number, zone: PropTypes.string })
    };
  }

  getRouteProps(field = 'start') {
    const { order, isManual } = this.props;
    if (!isManual) return {};

    return {
      'data-field-id': `events.${field}`,
      'data-field-route': `/events/${order}`
    };
  }

  renderTimes(start, end) {
    const { isManual } = this.props;

    if (isManual && !start) {
      return null;
    }

    const formattedStart = isManual ? start : (start || '').toLocaleString(HOUR_FORMAT);
    const formattedEnd = isManual ? end : (end || '').toLocaleString(HOUR_FORMAT);
    const startEl = formattedStart ? (
      <UX2.Element.Heading.Minor { ...this.getRouteProps('start') } style={ styles }>
        { formattedStart }
      </UX2.Element.Heading.Minor>
    ) : null;
    const endEl = formattedEnd ? (
      <UX2.Element.Heading.Minor { ...this.getRouteProps('end') } style={ styles }>
        { formattedEnd }
      </UX2.Element.Heading.Minor>
    ) : null;
    const separator = start && end ? (
      <UX2.Element.Heading.Minor style={{ paddingHorizontal: 'xsmall', ...styles }}> - </UX2.Element.Heading.Minor>
    ) : null;

    return (
      <UX2.Element.Block>
        { startEl }
        { separator }
        { endEl }
      </UX2.Element.Block>
    );
  }

  render() {
    const { locale, allDay, isManual, timezone, staticContent = {}, order } = this.props;
    let start = this.props.start,
      end = this.props.end;
    if (!isManual) {
      start = new DateWrapper(this.props.start);
      end = new DateWrapper(this.props.end);

      if (timezone) {
        start.set('timeZoneOffset', timezone.offset);
        end.set('timeZoneOffset', timezone.offset);
      } else {
        start.set('timeZoneOffset', getTimeZoneOffset(this.props.start));
        end.set('timeZoneOffset', getTimeZoneOffset(this.props.end));
      }
      start.locale(locale);
      end.locale(locale);
    }

    const eventTimeContent = allDay ? (
      <UX2.Element.Heading.Minor data-route={ isManual && `events/${order}` }>
        { staticContent.allDay }
      </UX2.Element.Heading.Minor>
    ) : this.renderTimes(start, end);

    return (
      <UX2.Element.Block data-aid={ DataAid.CALENDAR_EVENT_TIME }>
        { eventTimeContent }
      </UX2.Element.Block>
    );
  }
}

export default EventTime;
